import Tooltip from '@mui/material/Tooltip';
import Protect from 'app/components/Protect';
import TransportActivity2216Icon from 'app/icons/TransportActivity2216Icon';
import TransportActivityOffIcon from 'app/icons/TransportActivityOffIcon';
import TransportConditionAlarmIcon from 'app/icons/TransportConditionAlarmIcon';
import TransportConditionGeofenceBaseIcon from 'app/icons/TransportConditionGeofenceBaseIcon';
import TransportConditionGeofenceCheckpointIcon from 'app/icons/TransportConditionGeofenceCheckpointIcon';
import TransportConditionGeofenceControlIcon from 'app/icons/TransportConditionGeofenceControlIcon';
import TransportConditionGeofenceDrainIcon from 'app/icons/TransportConditionGeofenceDrainIcon';
import TransportConditionGeofenceEmptyIcon from 'app/icons/TransportConditionGeofenceEmptyIcon';
import TransportConditionGeofenceFullIcon from 'app/icons/TransportConditionGeofenceFullIcon';
import TransportConditionGeofencePouringIcon from 'app/icons/TransportConditionGeofencePouringIcon';
import TransportConditionGeofenceQueueIcon from 'app/icons/TransportConditionGeofenceQueueIcon';
import TransportConditionGeofenceRepairIcon from 'app/icons/TransportConditionGeofenceRepairIcon';
import TransportConditionLockSecondaryIcon from 'app/icons/TransportConditionLockSecondaryIcon';
import TransportConditionLockSuccessIcon from 'app/icons/TransportConditionLockSuccessIcon';
import TransportConditionParkingAlarmIcon from 'app/icons/TransportConditionParkingAlarmIcon';
import TransportConditionParkingIcon from 'app/icons/TransportConditionParkingIcon';
import TransportConditionParkingLongIcon from 'app/icons/TransportConditionParkingLongIcon';
import TransportConditionParkingWarningIcon from 'app/icons/TransportConditionParkingWarningIcon';
import TransportConditionSDCardIcon from 'app/icons/TransportConditionSDCardIcon';
import TransportConditionSignalOffIcon from 'app/icons/TransportConditionSignalOffIcon';
import TransportConditionSpeedIcon from 'app/icons/TransportConditionSpeedIcon';
import TransportConditionTrailerIcon from 'app/icons/TransportConditionTrailerIcon';
import TransportConditionVoltageIcon from 'app/icons/TransportConditionVoltageIcon';
import TransportConditionWarningIcon from 'app/icons/TransportConditionWarningIcon';
import { usePermission, useRoles } from 'app/services';
import { formatGuardBits, getLastConditionData, getLastTransportCondition } from 'app/types';
import { isActivity2216Red } from 'app/utils/activity2216';
import { NONEMPTY_DUT_THRESHOLD, PARKING_ALERT_SECONDS, PARKING_LONG_SECONDS } from 'app/utils/nonemptyOilParkingAlert';
import React, { forwardRef } from 'react';
const IconComponent = forwardRef(function IconComponent(props, ref) {
    return React.createElement("div", Object.assign({ ref: ref }, props));
});
const OIL_TRAILER_SECTION_TYPE = 'Нефть';
function sumDutValues(data) {
    return config.numberOfTank
        .map((number) => data[`dut${number}`])
        .filter((number) => number !== config.conditions.dut.default)
        .reduce((a, b) => a + b, 0);
}
function isOilTrailer(tank) {
    if (!Array.isArray(tank)) {
        return false;
    }
    return tank.some((section) => Array.isArray(section) && section[1] === OIL_TRAILER_SECTION_TYPE);
}
function getSignalDiff(datetime, receiveDate) {
    return Math.max(0, moment(datetime).diff(moment(receiveDate).endOf('minute')));
}
const MapTransportConditionIconsList = (props) => {
    const { data, history, datetime, zoom, conditions } = props;
    const hasActivityPermission = usePermission('activity');
    const isSuperAdmin = useRoles([config.userRoles.SUPERADMIN]);
    const canViewActivity2216ByRole = useRoles([
        config.userRoles.SUPERADMIN,
        config.userRoles.ADMIN,
        config.userRoles.MECHANIC,
        config.userRoles.ENGINEER,
    ]);
    const canViewActivity2216 = hasActivityPermission || canViewActivity2216ByRole;
    const Activity2216Icon = hasActivityPermission ? TransportActivityOffIcon : TransportActivity2216Icon;
    const hasWialon2216Device = data.wialon_type === 2 || Boolean(data.wialon_imei);
    const lastCondition = getLastTransportCondition(conditions);
    const lastData = getLastConditionData(conditions);
    const hasConditions = !!lastCondition && !!lastData;
    const deviceType = config.transportDeviceTypes[data.device_type];
    const renderParkingIcon = () => {
        if (!lastData) {
            return null;
        }
        if (deviceType === 'onlyWialon') {
            return (React.createElement(Tooltip, { title: '\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C', placement: 'top', disableInteractive: true, arrow: true },
                React.createElement(IconComponent, null,
                    React.createElement(TransportConditionSpeedIcon, { fontSize: 'medium', color: lastData.speed > config.speedLimit ? 'error' : 'success' }, lastData.speed === config.conditions.speed.default ? 0 : Math.ceil(Number(lastData.speed))))));
        }
        if (deviceType !== 'galileosky') {
            return null;
        }
        switch (lastData.is_parked) {
            case 0:
                if (lastData.acc_status !== config.conditions.acc_status.default) {
                    return (React.createElement(Tooltip, { title: '\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C', placement: 'top', disableInteractive: true, arrow: true },
                        React.createElement(IconComponent, null,
                            React.createElement(TransportConditionSpeedIcon, { fontSize: 'medium', color: lastData.can_speed > config.speedLimit ? 'error' : 'success' }, lastData.can_speed === config.conditions.can_speed.default ? 0 : Math.ceil(Number(lastData.can_speed))))));
                }
                return null;
            case 1:
                if (lastData.geofence_name === 'NA') {
                    switch (lastData.parking_overtime) {
                        case 0:
                            return (React.createElement(Tooltip, { title: '\u0421\u0442\u043E\u044F\u043D\u043A\u0430 \u0434\u043E 10 \u043C\u0438\u043D\u0443\u0442', placement: 'top', disableInteractive: true, arrow: true },
                                React.createElement(IconComponent, null,
                                    React.createElement(TransportConditionParkingIcon, { fontSize: 'medium' }))));
                        case 1: {
                            const parkingTime = Number(lastData.parking_time || 0);
                            if (parkingTime > PARKING_LONG_SECONDS) {
                                return (React.createElement(Tooltip, { title: '\u0421\u0442\u043E\u044F\u043D\u043A\u0430 \u043E\u0442 6 \u0447\u0430\u0441\u043E\u0432', placement: 'top', disableInteractive: true, arrow: true },
                                    React.createElement(IconComponent, null,
                                        React.createElement(TransportConditionParkingLongIcon, { fontSize: 'medium' }))));
                            }
                            if (parkingTime > PARKING_ALERT_SECONDS && isOilTrailer(data.tank) && sumDutValues(lastData) > NONEMPTY_DUT_THRESHOLD) {
                                return (React.createElement(Tooltip, { title: '\u0421\u0442\u043E\u044F\u043D\u043A\u0430 \u043D\u0435\u043F\u0443\u0441\u0442\u043E\u0433\u043E \u043D\u0435\u0444\u0442\u0435\u0432\u043E\u0437\u0430 \u043E\u0442 15 \u043C\u0438\u043D\u0443\u0442', placement: 'top', disableInteractive: true, arrow: true },
                                    React.createElement(IconComponent, null,
                                        React.createElement(TransportConditionParkingWarningIcon, { fontSize: 'medium' }))));
                            }
                            return (React.createElement(Tooltip, { title: '\u0421\u0442\u043E\u044F\u043D\u043A\u0430 \u043E\u0442 10 \u043C\u0438\u043D\u0443\u0442', placement: 'top', disableInteractive: true, arrow: true },
                                React.createElement(IconComponent, null,
                                    React.createElement(TransportConditionParkingAlarmIcon, { fontSize: 'medium' }))));
                        }
                    }
                }
                return null;
            default:
                return null;
        }
    };
    const renderGuardIcon = () => {
        if (!lastData || deviceType !== 'galileosky' || lastData.guard_out === config.conditions.guard_out.default) {
            return null;
        }
        const guardOut = formatGuardBits(Number(lastData.guard_out));
        const guardStatusSum = sumDutValues(lastData);
        if (guardOut[1] !== '1') {
            return null;
        }
        if (guardStatusSum >= 200) {
            return (React.createElement(Tooltip, { title: '\u041C\u0430\u0448\u0438\u043D\u0430 \u043F\u043E\u0434 \u043E\u0445\u0440\u0430\u043D\u043E\u0439, \u0451\u043C\u043A\u043E\u0441\u0442\u0438 \u043D\u0435 \u043F\u0443\u0441\u0442\u044B\u0435', placement: 'top', disableInteractive: true, arrow: true },
                React.createElement(IconComponent, null,
                    React.createElement(TransportConditionLockSuccessIcon, { fontSize: 'medium' }))));
        }
        return (React.createElement(Tooltip, { title: '\u041C\u0430\u0448\u0438\u043D\u0430 \u043F\u043E\u0434 \u043E\u0445\u0440\u0430\u043D\u043E\u0439, \u0451\u043C\u043A\u043E\u0441\u0442\u0438 \u043F\u0443\u0441\u0442\u044B\u0435', placement: 'top', disableInteractive: true, arrow: true },
            React.createElement(IconComponent, null,
                React.createElement(TransportConditionLockSecondaryIcon, { fontSize: 'medium' }))));
    };
    const renderGeofenceIcon = () => {
        if (!lastData || deviceType !== 'galileosky' || zoom || lastData.geofence_name === 'NA') {
            return null;
        }
        const guardStatus = formatGuardBits(Number(lastData.guard_status));
        const guardStatusSum = sumDutValues(lastData);
        switch (lastData.geofence_type) {
            case 1:
                if (guardStatus[2] === '0') {
                    if (guardStatusSum >= 200) {
                        return (React.createElement(Tooltip, { title: '\u041C\u0430\u0448\u0438\u043D\u0430 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u0433\u0440\u0443\u043F\u043F\u0435 \u0437\u043E\u043D \u0410\u0417\u0421 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u0430\u044F', placement: 'top', disableInteractive: true, arrow: true },
                            React.createElement(IconComponent, null,
                                React.createElement(TransportConditionGeofenceFullIcon, { fontSize: 'medium' }))));
                    }
                    return (React.createElement(Tooltip, { title: '\u041C\u0430\u0448\u0438\u043D\u0430 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u0433\u0440\u0443\u043F\u043F\u0435 \u0437\u043E\u043D \u0410\u0417\u0421 \u043F\u0443\u0441\u0442\u0430\u044F', placement: 'top', disableInteractive: true, arrow: true },
                        React.createElement(IconComponent, null,
                            React.createElement(TransportConditionGeofenceEmptyIcon, { fontSize: 'medium' }))));
                }
                if (Number(lastData.dun_cover) > 30) {
                    return (React.createElement(Tooltip, { title: '\u041C\u0430\u0448\u0438\u043D\u0430 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u0433\u0440\u0443\u043F\u043F\u0435 \u0437\u043E\u043D \u0410\u0417\u0421 \u043D\u0430 \u0441\u043B\u0438\u0432\u0435', placement: 'top', disableInteractive: true, arrow: true },
                        React.createElement(IconComponent, null,
                            React.createElement(TransportConditionGeofenceDrainIcon, { fontSize: 'medium' }))));
                }
                return null;
            case 2:
                return (React.createElement(Tooltip, { title: '\u041C\u0430\u0448\u0438\u043D\u0430 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u043D\u0430 \u0431\u0430\u0437\u0435', placement: 'top', disableInteractive: true, arrow: true },
                    React.createElement(IconComponent, null,
                        React.createElement(TransportConditionGeofenceBaseIcon, { fontSize: 'medium' }))));
            case 3:
                return (React.createElement(Tooltip, { title: '\u041C\u0430\u0448\u0438\u043D\u0430 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u0437\u043E\u043D\u0435 \u043D\u0430\u043B\u0438\u0432\u0430', placement: 'top', disableInteractive: true, arrow: true },
                    React.createElement(IconComponent, null,
                        React.createElement(TransportConditionGeofencePouringIcon, { fontSize: 'medium' }))));
            case 4:
                return (React.createElement(Tooltip, { title: '\u0413\u0435\u043E\u0437\u043E\u043D\u0430 \u0432 \u0433\u0440\u0443\u043F\u043F\u0435 \u0437\u043E\u043D \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044F', placement: 'top', arrow: true },
                    React.createElement(IconComponent, null,
                        React.createElement(TransportConditionGeofenceControlIcon, { fontSize: 'medium' }))));
            case 5:
                return (React.createElement(Tooltip, { title: '\u0413\u0435\u043E\u0437\u043E\u043D\u0430 \u0432 \u0433\u0440\u0443\u043F\u043F\u0435 \u0437\u043E\u043D \u0440\u0435\u043C\u043E\u043D\u0442', placement: 'top', disableInteractive: true, arrow: true },
                    React.createElement(IconComponent, null,
                        React.createElement(TransportConditionGeofenceRepairIcon, { fontSize: 'medium' }))));
            case 7:
                return (React.createElement(Tooltip, { title: '\u0413\u0435\u043E\u0437\u043E\u043D\u0430 \u0432 \u0433\u0440\u0443\u043F\u043F\u0435 \u0437\u043E\u043D \u0432\u044A\u0435\u0437\u0434/\u043A\u043F\u043F', placement: 'top', disableInteractive: true, arrow: true },
                    React.createElement(IconComponent, null,
                        React.createElement(TransportConditionGeofenceCheckpointIcon, { fontSize: 'medium' }))));
            case 8:
                return (React.createElement(Tooltip, { title: '\u0413\u0435\u043E\u0437\u043E\u043D\u0430 \u0432 \u0433\u0440\u0443\u043F\u043F\u0435 \u0437\u043E\u043D \u043E\u0447\u0435\u0440\u0435\u0434\u044C', placement: 'top', disableInteractive: true, arrow: true },
                    React.createElement(IconComponent, null,
                        React.createElement(TransportConditionGeofenceQueueIcon, { fontSize: 'medium' }))));
            default:
                return null;
        }
    };
    const renderAlarmIcons = () => {
        if (!lastData || deviceType !== 'galileosky' || lastData.guard_status === config.conditions.guard_status.default) {
            return [];
        }
        const guardStatus = formatGuardBits(Number(lastData.guard_status));
        const components = [];
        switch (guardStatus[1]) {
            case '0':
                if (guardStatus[2] === '1') {
                    switch (lastData.geofence_type) {
                        case 1:
                        case 3:
                            break;
                        default:
                            if (!zoom) {
                                components.push(React.createElement(Tooltip, { key: 0, title: '\u041A\u0440\u044B\u0448\u043A\u0430 \u0441\u043B\u0438\u0432\u0430 \u043E\u0442\u043A\u0440\u044B\u0442\u0430', placement: 'top', disableInteractive: true, arrow: true },
                                    React.createElement(IconComponent, null,
                                        React.createElement(TransportConditionWarningIcon, { fontSize: 'medium' }))));
                            }
                    }
                }
                break;
            case '1':
                components.push(React.createElement(Tooltip, { key: 1, title: '\u0422\u0440\u0435\u0432\u043E\u0433\u0430', placement: 'top', disableInteractive: true, arrow: true },
                    React.createElement(IconComponent, null,
                        React.createElement(TransportConditionAlarmIcon, { fontSize: 'medium' }))));
                break;
        }
        if (guardStatus[0] === '1' && !zoom) {
            components.push(React.createElement(Tooltip, { key: 2, title: '\u041D\u0430\u0440\u0443\u0448\u0435\u043D\u0430 \u0441\u0432\u044F\u0437\u044C \u0441 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u043C', placement: 'top', disableInteractive: true, arrow: true },
                React.createElement(IconComponent, null,
                    React.createElement(TransportConditionTrailerIcon, { fontSize: 'medium' }))));
        }
        return components;
    };
    const renderSignalOffIcon = () => {
        if (history || !lastCondition) {
            return null;
        }
        const diff = getSignalDiff(datetime, lastCondition.receive_date);
        if (diff > config.signalOffTimeout[0].interval[1]) {
            return (React.createElement(Tooltip, { title: '\u041F\u043E\u0442\u0435\u0440\u044F \u0441\u0432\u044F\u0437\u0438', placement: 'top', disableInteractive: true, arrow: true },
                React.createElement(IconComponent, null,
                    React.createElement(TransportConditionSignalOffIcon, { fontSize: 'medium', color: config.signalOffTimeout[0].color }))));
        }
        return null;
    };
    const renderVoltageIcon = () => {
        if (zoom || !lastData || deviceType !== 'galileosky' || lastData.voltage === config.conditions.voltage.default) {
            return null;
        }
        if (Number(lastData.voltage) < config.voltageLimit) {
            return (React.createElement(Tooltip, { title: '\u041C\u0430\u0441\u0441\u0430 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0430', placement: 'top', disableInteractive: true, arrow: true },
                React.createElement(IconComponent, null,
                    React.createElement(TransportConditionVoltageIcon, { fontSize: 'medium' }))));
        }
        return null;
    };
    const renderSdCardIcon = () => {
        if (!lastData || deviceType !== 'galileosky' || zoom) {
            return null;
        }
        const deviceExtStatusValue = lastData.device_ext_status;
        if (deviceExtStatusValue === config.conditions.device_ext_status.default || deviceExtStatusValue == null) {
            return null;
        }
        const deviceExtStatus = formatGuardBits(Number(deviceExtStatusValue), 7);
        if (deviceExtStatus[0] === '0') {
            return (React.createElement(Tooltip, { title: '\u041E\u0448\u0438\u0431\u043A\u0430 SD \u043A\u0430\u0440\u0442\u044B', placement: 'top', disableInteractive: true, arrow: true },
                React.createElement(IconComponent, null,
                    React.createElement(TransportConditionSDCardIcon, { fontSize: 'medium' }))));
        }
        return null;
    };
    const renderActivitySignalIcon = () => {
        if (!hasConditions || !lastCondition) {
            return (React.createElement(Tooltip, { title: '\u041F\u043E\u0442\u0435\u0440\u044F \u0441\u0432\u044F\u0437\u0438', placement: 'top', disableInteractive: true, arrow: true },
                React.createElement(IconComponent, null,
                    React.createElement(TransportConditionSignalOffIcon, { fontSize: 'medium', color: config.signalOffTimeout[0].color }))));
        }
        const diff = getSignalDiff(datetime, lastCondition.receive_date);
        if (diff > config.signalOffTimeout[1].interval[0]) {
            const matched = config.signalOffTimeout.slice(1).find((signalOff) => diff >= signalOff.interval[0] && diff <= signalOff.interval[1]);
            const color = matched === null || matched === void 0 ? void 0 : matched.color;
            if (!color) {
                return null;
            }
            return (React.createElement(Tooltip, { title: '\u041F\u043E\u0442\u0435\u0440\u044F \u0441\u0432\u044F\u0437\u0438', placement: 'top', disableInteractive: true, arrow: true },
                React.createElement(IconComponent, null,
                    React.createElement(TransportConditionSignalOffIcon, { fontSize: 'medium', color: color }))));
        }
        return null;
    };
    const renderActivity2216Icon = () => {
        if (!canViewActivity2216 || !hasWialon2216Device) {
            return null;
        }
        const isRed = isActivity2216Red(datetime, data.last_motion_galileosky_date, data.last_activity_date);
        if (isRed) {
            return (React.createElement(Tooltip, { title: config.activity2216RedTooltip, placement: 'top', disableInteractive: true, arrow: true },
                React.createElement(IconComponent, null,
                    React.createElement(Activity2216Icon, { fontSize: 'medium', color: 'error' }))));
        }
        // Зелёный / оранжевый — только супер-админ, по свежести last_activity_date (без старого красного > 3 ч).
        if (!isSuperAdmin || !data.last_activity_date) {
            return null;
        }
        const diff = Math.max(0, moment(datetime).diff(moment(data.last_activity_date).endOf('minute')));
        const activity = config.activityTimeout.find((a) => a.color !== 'error' && diff >= a.interval[0] && diff <= a.interval[1]);
        if (!activity) {
            return null;
        }
        return (React.createElement(Tooltip, { title: activity.tooltip, placement: 'top', disableInteractive: true, arrow: true },
            React.createElement(IconComponent, null,
                React.createElement(Activity2216Icon, { fontSize: 'medium', color: activity.color }))));
    };
    return (React.createElement(React.Fragment, null,
        hasConditions && (React.createElement(Protect, { permissions: ['read', 'readonly'], renderPermitted: () => (React.createElement(React.Fragment, null,
                React.createElement(React.Fragment, { key: 'parking' }, renderParkingIcon()),
                React.createElement(React.Fragment, { key: 'guard' }, renderGuardIcon()),
                React.createElement(React.Fragment, { key: 'geofence' }, renderGeofenceIcon()),
                React.createElement(React.Fragment, { key: 'alarm' }, renderAlarmIcons()),
                React.createElement(React.Fragment, { key: 'signal' }, renderSignalOffIcon()),
                React.createElement(React.Fragment, { key: 'voltage' }, renderVoltageIcon()),
                React.createElement(React.Fragment, { key: 'sd' },
                    React.createElement(Protect, { permissions: 'sd', renderPermitted: () => React.createElement(React.Fragment, null, renderSdCardIcon()), renderForbidden: () => React.createElement(React.Fragment, null) })))), renderForbidden: () => React.createElement(React.Fragment, null) })),
        !hasConditions && (React.createElement(Protect, { permissions: ['read', 'readonly'], renderPermitted: () => (React.createElement(React.Fragment, null,
                React.createElement(React.Fragment, { key: 'signal' },
                    React.createElement(Tooltip, { title: '\u041F\u043E\u0442\u0435\u0440\u044F \u0441\u0432\u044F\u0437\u0438', placement: 'top', disableInteractive: true, arrow: true },
                        React.createElement(IconComponent, null,
                            React.createElement(TransportConditionSignalOffIcon, { fontSize: 'medium', color: config.signalOffTimeout[0].color })))))), renderForbidden: () => React.createElement(React.Fragment, null) })),
        React.createElement(React.Fragment, { key: 'signal' },
            React.createElement(React.Fragment, { key: 0 },
                React.createElement(Protect, { permissions: 'activity', renderPermitted: () => React.createElement(React.Fragment, null, renderActivitySignalIcon()), renderForbidden: () => React.createElement(React.Fragment, null) })),
            React.createElement(React.Fragment, { key: 1 }, renderActivity2216Icon()))));
};
export default MapTransportConditionIconsList;
